import {defineNuxtPlugin} from '#app';
import {useMaltEnvironnement} from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
    const maltEnvironnement = useMaltEnvironnement();

    if (typeof window !== 'undefined' && import.meta.dev && maltEnvironnement === 'DEV_INTEGRATION') {
        /** Call once so it logs the message after the page is fully loaded, and not at every navigation */
        nuxtApp.hook('app:mounted', () => {
            // eslint-disable-next-line no-console
            console.warn(
                '%cDEV_INTEGRATION mode enabled',
                'color: white; font-weight: bold; background:rgb(223, 21, 21); padding: 2px 8px; border-radius: 3px;',
            );
        });
    }
});
